import { TFunction } from 'i18next';

export class AuthError extends Error {
  constructor(
    readonly code: string,
    message: string,
  ) {
    super(message);
  }

  getLabel(t: TFunction) {
    switch (this.code) {
      case 'auth/email-already-exists':
      case 'auth/email-already-in-use':
        return t('auth.errors.auth/email-already-in-use');
      case 'auth/invalid-credential':
        return t('auth.errors.auth/invalid-credential');
      case 'auth/invalid-login-credentials': // Firebase does not expose this error code
        return t('auth.errors.auth/invalid-login-credentials');
      case 'auth/invalid-email':
        return t('auth.errors.auth/invalid-email');
      case 'auth/operation-not-allowed':
        return t('auth.errors.auth/operation-not-allowed');
      case 'auth/internal-error':
        return t('auth.errors.auth/internal-error');
      case 'auth/invalid-provider-id':
        return t('auth.errors.auth/invalid-provider-id');
      case 'auth/too-many-requests':
        return t('auth.errors.auth/too-many-requests');
      case 'auth/invalid-password':
        return t('auth.errors.auth/invalid-password');
      case 'auth/weak-password':
        return t('auth.errors.auth/weak-password');
      case 'auth/network-request-failed':
        return t('auth.errors.auth/network-request-failed');
      case 'auth/expired-action-code':
        return t('auth.errors.auth/expired-action-code');
      case 'auth/invalid-action-code':
        return t('auth.errors.auth/invalid-action-code');
      case 'auth/user-disabled':
        return t('auth.errors.auth/user-disabled');
      case 'auth/user-not-found':
        return t('auth.errors.auth/user-not-found');
      default:
        return t('auth.errors.default');
    }
  }
}
